module.exports = __webpack_public_path__ + "img/facebook.9293215d.svg";